<template>
  <div>
    <m-add-references ref="add" :field-name="fieldName" :list="values" @add="addVariants" />
    <m-reference-list
      ref="list"
      :field-name="fieldName"
      :list="list"
      @addVariant="addVariant"
      @removeVariant="removeVariant"
      @updated="submit"
    />
  </div>
</template>

<script>
import { FieldVariant } from "@/domains/profile/models/ProfileFieldVariant";
import MAddReferences from "./AddReferences";
import MReferenceList from "./ReferenceList";

export default {
  components: { MAddReferences, MReferenceList },
  props: ["fieldName"],
  data() {
    return {
      list: [],
    };
  },
  computed: {
    values() {
      return this.list.map((i) => i.text);
    },
  },
  methods: {
    open(list) {
      const copy = [...list];
      copy.sort((a, b) => (a.text.toLowerCase() > b.text.toLowerCase() ? 1 : -1));
      this.list = copy;
      if (this.list.length) this.$refs.list.open();
      else this.$refs.add.open();
    },
    addVariants(variants) {
      const newVariants = variants.map((v) => FieldVariant(v));
      this.list = [...this.list, ...newVariants];
      this.$refs.list.open(newVariants[0].unique);
    },
    addVariant() {
      this.$refs.add.open();
    },
    removeVariant(variant) {
      this.list = this.list.filter((v) => v !== variant);
    },
    submit() {
      this.$emit("updated", this.list);
    },
  },
};
</script>
